import React from "react"
import Stores from "../stores"

class Over1000Store extends React.Component {
  render() {
    return (
      <div className="over-1000-store">
        <div className="container">
          <div data-aos="fade-up" className="has-text-centered">
            <h2 className="title is-2 mb-0">OVER 1000 STORE</h2>
            <small className="has-text-grey-light">
              提携店舗は1000店舗以上
            </small>
          </div>
          <div data-aos="fade-up" className="mt-40">
            <Stores />
          </div>
        </div>
      </div>
    )
  }
}

export default Over1000Store
